import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../../context/AppContext";
import { BASE_URL } from "../../services/api";
import "./Login.css";

export default function Login({ onLogin }) {
  const { dispatch } = useApp();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("Please enter username and password");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${BASE_URL}Auth/login.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ LoginID: username, password: password })
        }
      );

      const data = await response.json();

      if (data.success && data.user) {
        sessionStorage.setItem("token", data.token || "");
        sessionStorage.setItem("user", JSON.stringify(data.user));
        dispatch({ type: 'LOGIN', payload: data.user });
        if (onLogin) onLogin(data.user);
      } else {
        setError(data.message || "Invalid credentials or user data");
      }
    } catch (err) {
      console.error(err);
      setError("Unable to connect to server");
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-logo">⛽</div>
          <h1 className="login-app-name">Petro Genius</h1>
          <p className="login-tagline">Fuel Station Management System</p>
        </div>

        <form className="login-form" onSubmit={handleLogin}>
          <h2 className="login-title">Sign In</h2>

          {error && <div className="login-error">⚠️ {error}</div>}

          <div className="login-field">
            <label>Login ID</label>
            <input
              type="text"
              placeholder="Enter mobile number"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="login-field">
            <label>Password</label>
            <div className="input-wrap">
              <input
                type={showPass ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="show-pass"
                onClick={() => setShowPass(!showPass)}
              >
                {showPass ? "🙈" : "👁"}
              </button>
            </div>
            <div style={{ textAlign: 'right', marginTop: '6px' }}>
              <span 
                onClick={() => navigate('/forgot-password')} 
                style={{ fontSize: '12px', color: '#1a2b3c', cursor: 'pointer', fontWeight: '800' }}
              >
                Forgot password?
              </span>
            </div>
          </div>

          <button className="login-btn" disabled={loading} style={{ marginBottom: '16px' }}>
            {loading ? "Processing..." : "Sign In"}
          </button>

          <button 
            type="button" 
            className="login-btn" 
            style={{ background: 'transparent', border: '1.5px solid #1a2b3c', color: '#1a2b3c' }}
            onClick={() => navigate('/register-company')}
          >
            Create Company Account
          </button>
        </form>
      </div>
    </div>
  );
}